<template>
  <div>
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-navbar-brand href="#">
        <img class="navbar-brand-full" :src="getLogoImg()" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item>
            <!-- <b-icon-list v-b-toggle.sidebar-1 /> -->
          </b-nav-item>
          <b-nav-item to="/home">
            <b-icon-house></b-icon-house>
          </b-nav-item>
          <b-nav-item v-if="HasPermission('CLOSER-not')" @click="GotoCloser({ link: '/' })">Closer</b-nav-item>          

          <b-nav-dropdown v-for="(m, i) in GetMenu()" :key="i" :text="m.text" v-if="HasPermission(m.permission)">
            <b-dropdown-item v-for="(t, j) in m.items.filter(x=> HasPermission(x.permission))" :key="j" v-if="m.items" :to="t.to">              
                {{ t.text }}                                
                <b-icon-box-arrow-up-right size="sm" class="clickable" @click="openlink($event,t)" title="Öppna i ny flik" font-scale="0.9"></b-icon-box-arrow-up-right>              
            </b-dropdown-item>
          </b-nav-dropdown>

        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <!-- <em>User</em> -->
              <b-icon-person-circle />
              {{ GetUserInfoText() }}
            </template>
            <!-- <b-dropdown-item href="#">Profil</b-dropdown-item> -->
            <b-dropdown-item href="#" @click="ResetLayouts()">Återställ fönster</b-dropdown-item>
            <b-dropdown-item href="#" @click="setPwdModal = true">Byt lösenord</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="Logout()">Logga ut</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-modal v-model="editVisible" size="xl" ok-only @ok="editOk" v-on:close="editOk" :no-close-on-backdrop="true"
      v-bind:no-close-on-esc="true">
      <todoedit ref="editor" v-bind:id="0"></todoedit>
    </b-modal>
    <b-modal ref="setPwdModal" title="Sätt lösenord" v-model="setPwdModal" ok-variant="secondary" ok-title="Avbryt"
      ok-only>
      <setpassword @newpassword="SetPwdOkHandler"></setpassword>
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import User from "../lib/user";
import todoedit from "./../views/todo/todoedit.vue";
import Settings from "./../lib/settings";
import setpassword from "./../views/party/setpassword.vue";

import { Api } from "../lib/api.js";
const api = new Api();
const usr = new User();

//TODO: Get from server
const AVAILABLE_PAGES = [
  { title: "Admin", desc: "Administration.", link: "/admin/index", permission: "EDI" },
  { title: "EDI", desc: "Hantering av EDI.", link: "/edi/index", permission: "EDI" },
  { title: "Godssökning", desc: "Se status på enskilda sändningar, sök efter fraktsedel, order eller kolli-ID.", link: "/search" },
  { title: "Rapporter", desc: "Se transporter, kvalitet och nyckeltal för transporterna.", link: "/reports/planned", permission: "REPORTS" },
  { title: "Fraktsedelsutskrift", desc: "Skriv ut fraktsedlar för leveranser och butikssedlar.", link: "/print/index", permission: "PRINT,STORE" },
  { title: "Mantelutskrift", desc: "Skriv ut mantelsedlar från lagren.", link: "/fastprint/index", permission: "FASTPRINT" },
  { title: "Avvikelsekod", desc: "Registrera och/eller sök avvikelsekod.", link: "/event/index", permission: "LISTEVENT,REGEVENT" },
  { title: "Kranbil", desc: "Registrera kranbil via mobil.", link: "/mobile/index", permission: "MOBILESTORE" },
  { title: "PreAdvice", desc: "PreAdvice adresslista.", link: "/preadvice/index", permission: "PREADVICE" },
  { title: "Butiksretur", desc: "Returbokning för butiker.", link: "/customer/storenewreturn", permission: "STORERETURN" },
  { title: "Skanna DC", desc: "Skanna på DC", link: "/mobile/scandc", permission: "SCANDC" }
];
// const CLOSER_BASE_URL = 'http://localhost:8081';

//TODO: Get from server
const MENU_BAR = [
{
    type: 'dropdown',
    text: 'GEO',
    permission: 'SYSADM,GEOPLAN,ADM',
    items: [
      {
        type: 'item',
        text: 'Planering',
        permission: 'SYSADM,GEOPLAN,ADM',
        to: '/plan'
      },
      // {
      //   type: 'item',
      //   text: 'Inställningar',
      //   permission: 'SYSADM,GEOPLAN,ADM',
      //   to: '/config'
      // },
    ]
  },
{
    type: 'dropdown',
    text: 'Ladda upp data',
    permission: 'SYSADM,ADM,GEOPLAN',
    items: [
      {
        type: 'item',
        text: 'Personregister',
        permission: 'SYSADM,GEOPLAN,ADM',
        to: '/registeraddresses'
      },
      {
        type: 'item',
        text: 'Order',
        permission: 'SYSADM,GEOPLAN,ADM',
        to: '/registerdata'
      },
    ]
  },
 {
    type: 'dropdown',
    text: 'Packning',
    permission: 'SYSADM,ADM,GEOPLAN',
    items: [
      {
        type: 'item',
        text: 'Registrering',
        permission: 'SYSADM,GEOPLAN,ADM',
        to: '/pack'
      }, 
      {
        type: 'item',
        text: 'Skriv ut lastbäraretiketter',
        permission: 'SYSADM,GEOPLAN,ADM',
        to: '/loadcarrierslist'
      }, 
      {
        type: 'item',
        text: 'Ställ in packare',
        permission: 'SYSADM,GEOPLAN,ADM',
        to: '/packerslist'
      }, 
    ]
  },
 
]

export default Vue.extend({
  name: "topbar",
  components: { todoedit, setpassword },
  data() {
    return {
      editVisible: false,
      setPwdModal: false,
    };
  },
  methods: {
    getLogoImg() {
      var imgFileName = Settings.customerLogoImg ? Settings.customerLogoImg: 'logivialogga_transp_min.png';
      return `/img/brand/${imgFileName}`;
    },
    Goto(url) {
      window.open(url);
    },
    GetUserInfoText() {
      return usr.GetUser().firstname;
    },
    HasPermission(perm) {
      return usr.HasPermission(perm);
    },
    Logout() {
      api.logout();
      this.$router.push({ path: "/pages/login" });
    },
    //TodoEditor
    editOk(ev) {
      if (this.$refs.editor.IsChanged()) {
        if (!confirm("Vill du verkligen stänga utan att spara?"))
          ev.preventDefault();
      }
      this.$refs.grid.GetData();
    },
    GetCloserPages() {
      return AVAILABLE_PAGES;
    },
    GotoCloser(l) {
      var link = Settings.closerClientUrl + l.link;
      this.Goto(link);
    },
    SetPwdOkHandler(pwd) {
      if (pwd.length > 0)
        api
          .post("/api/party/SetPwd", { userid: usr.GetUser().userid, pwd: pwd })
          .then((res) => {
            if (res.data) {
              alert(res.data);
            }
            if (res.status == 200) {
              alert("Lösenordet har uppdaterats.");
              this.setPwdModal = false;
            }
          });
    },
    ResetLayouts() {
      if (confirm('Återställ alla detaljfönsterinställningar till grundinställning?'))
        for (var key in localStorage) {
          if (key.startsWith('layout_'))
            localStorage.removeItem(key);
        }
      top.location.reload();
    },
    GetMenu() {
      return MENU_BAR;
    },
    openlink(e,t) {
      let lnk = '#'+t.to;
      window.open(lnk);
      e.preventDefault();
      
    }
  },
});
</script>